
export function removeFromArray(array: any, value: any) {
  const index = array?.indexOf(value)
  return index >= 0
    ? [...array.slice(0, index), ...array.slice(index + 1)]
    : array
}
